import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * FR-08 / issue #94: workflow handoffs surface as an in-app badge on the
 * recipient's queue page — My Work for analysts, the review queue for
 * supervisors and QA, the portal pages for client users.
 *
 * Extracted from Layout when the messaging widget added a second poller, so
 * both follow one pattern in one place. Polls for every signed-in member:
 * since issue #94 each persona can be notified, not only result-entry roles.
 */
export default function useNotifications({ user, organization, pathname }) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user || !organization) return undefined;
    const poll = async () => {
      try {
        const { data } = await api.get("/notifications");
        setUnread(data.filter((n) => !n.read).length);
      } catch {
        // Session may have just expired; the interceptor handles auth.
      }
    };
    poll();
    const timer = setInterval(poll, 60000);
    return () => clearInterval(timer);
    // Re-poll when navigating, so opening your queue clears the badge promptly.
  }, [user, organization, pathname]);

  return { unread };
}
